var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKomoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32c6.627 0 12-5.373 12-12S26.627 8 20 8 8 13.373 8 20s5.373 12 12 12Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.509 20c0 2.45.852 4.721 2.254 6.497l5.38-5.38a3.008 3.008 0 0 1-.214-1.135 3.09 3.09 0 0 1 3.089-3.089 3.091 3.091 0 0 1 3.089 3.089c0 .408-.071.78-.213 1.136l5.378 5.379A10.414 10.414 0 0 0 30.527 20c0-5.805-4.704-10.51-10.51-10.51C14.214 9.49 9.51 14.196 9.51 20Zm8.503 2.343-5.255 5.254a10.42 10.42 0 0 0 7.26 2.912c2.823 0 5.362-1.119 7.261-2.912l-5.272-5.254C21.953 22.396 20 19.2 20 19.2s-1.935 3.177-1.988 3.142Z",
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKomoot);
export default __webpack_public_path__ + "static/media/komoot.d7289003433fac15ebf8a26adc6d0928.svg";
export { ForwardRef as ReactComponent };